import user from './user'
import profile from './profile'
import alerts from './alerts'
import pets from './pets'
import appointment from './appointment'

export default {
  user,
  profile,
  alerts,
  pets,
  appointment,
}
